import React from 'react'
import { Checkbox as ShadcnCheckbox } from '@/components/ui/shadcn/checkbox'
import { cn } from '@/lib/utils'

export interface CheckboxProps extends React.ComponentProps<typeof ShadcnCheckbox> {
  label?: string
}

function Checkbox({ className, label, id, ref, ...props }: CheckboxProps) {
  if (label) {
    return (
      <div className="flex items-center space-x-2">
        <ShadcnCheckbox
          ref={ref}
          id={id}
          className={cn('cursor-pointer', className)}
          {...props}
        />
        <label
          htmlFor={id}
          className="text-sm font-medium leading-none cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {label}
        </label>
      </div>
    )
  }

  return (
    <ShadcnCheckbox
      ref={ref}
      id={id}
      className={cn('cursor-pointer', className)}
      {...props}
    />
  )
}

export { Checkbox }
